import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * A route change keeps the window's scroll position, so opening a coach or a
 * location from halfway down Home landed the detail page mid-content.
 *
 * Watches the pathname only: booking filters and the dashboard's sections live
 * in the query string, and jumping to the top every time one changes would
 * yank the page away from whatever the client was reading. POP (browser back /
 * forward) is left alone so returning to a list keeps the position it had.
 */
function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") return;
    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
}

export default ScrollToTop;
